import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-118f1884"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center flex-grow-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "m-0 text-center" }, " Advance Search ")
], -1))
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "pl-lg-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "search-report-start"
}, "Start date", -1))
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "search-alarm-end"
}, "End date", -1))
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "search-alarm-level"
}, "Level", -1))
const _hoisted_15 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_drawer_content = _resolveComponent("n-drawer-content")!
  const _component_n_drawer = _resolveComponent("n-drawer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_n_drawer, {
      show: _ctx.drawer,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.drawer) = $event)),
      placement: "bottom",
      height: "80%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_drawer_content, {
          "header-style": "display: block !important;",
          "footer-style": "display: block !important;"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", null, [
                _createVNode(_component_el_icon, { onClick: _ctx.openAdvanceSearch }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Close)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _hoisted_2,
              _createElementVNode("div", null, [
                _createVNode(_component_n_button, {
                  quaternary: "",
                  onClick: _ctx.resetMobile
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Reset ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_n_button, {
                class: "flex-fill",
                type: "primary",
                disabled: _ctx.alarmFilter.isEmpty,
                onClick: _ctx.searchingMobile
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" SHOW RESULTS ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_n_space, { vertical: "" }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("form", { key: _ctx.alarmFilter }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createVNode(_component_n_date_picker, {
                            id: "search-alarm-start",
                            value: _ctx.startDatetime,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDatetime) = $event)),
                            type: "date",
                            format: "yyyy-MM-dd",
                            size: "large",
                            clearable: "",
                            "is-date-disabled": _ctx.startDateDisabled,
                            "is-time-disabled": _ctx.startTimeDisabled,
                            "on-update:show": _ctx.onStartChanged
                          }, null, 8, ["value", "is-date-disabled", "is-time-disabled", "on-update:show"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createVNode(_component_n_date_picker, {
                            id: "search-alarm-end",
                            value: _ctx.endDatetime,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDatetime) = $event)),
                            type: "date",
                            format: "yyyy-MM-dd",
                            size: "large",
                            clearable: "",
                            disabled: !_ctx.startDatetime,
                            "is-date-disabled": _ctx.endDateDisabled,
                            "is-time-disabled": _ctx.endTimeDisabled,
                            "on-update:show": _ctx.onEndChanged
                          }, null, 8, ["value", "disabled", "is-date-disabled", "is-time-disabled", "on-update:show"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_n_select, {
                            id: "search-alarm-level",
                            value: _ctx.alarmFilter.level,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.alarmFilter.level) = $event)),
                            options: _ctx.levelOptions,
                            loading: _ctx.levelLoading,
                            filterable: "",
                            clearable: "",
                            size: "large",
                            onSearch: _ctx.onLevelSearch
                          }, null, 8, ["value", "options", "loading", "onSearch"])
                        ])
                      ])
                    ])
                  ])
                ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_n_button, {
        strong: "",
        secondary: "",
        type: "primary",
        class: "flex-fill m-3",
        onClick: _ctx.openAdvanceSearch
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Advance Search ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}